import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { memberMobx } from '@mobxStore'
import { favoMobx, cartMobx } from 'mobx/mall'
import { IonFooter } from '@ionic/react'
import { useHistoryNew } from '@utils'
import { format } from '@dt/fe-utils'
import './index.scss'

const CollectFooter: FC = () => {
  const history = useHistoryNew()
  const [allPrice, setAllPrice] = useState<number>(0)
  const products = favoMobx.productList || []
  const selectProductNoList = favoMobx.selectProductNoList || {}
  const handleToCart = () => {
    if (!memberMobx.isLogin) return history.push('/login')
    favoMobx.addToCart()
    if (cartMobx.cartItems.length) {
      history.push('/mcheckout')
    }
  }

  useEffect(() => {
    let _allPrice: number = 0
    products.forEach((product) => {
      if (favoMobx.selectProductNoMap[product.no]) {
        (product.selectScales || []).forEach((item) => {
          _allPrice += item.price * item.selectCnt
        })
      }
    })
    setAllPrice(_allPrice)
  }, [JSON.stringify(selectProductNoList), JSON.stringify(products)])

  return (
    <IonFooter className='mall-favo-footer'>
      <div className='cart-button-footer'>
        <button className='default-btn btn' onClick={() => history.goBack()}>{i18n.t('common.back')}</button>
        <button className='btn primary-btn' onClick={handleToCart}>
          {allPrice > 0 && <span className='price-wrap'>{format.toPrice(allPrice)}</span>}{i18n.t('pay.pay')}
        </button>
      </div>
    </IonFooter>
  )
}

export default observer(CollectFooter)
